import { Box, Typography } from "@mui/material";
import { useContactCenterTheme } from "../../virtual-receptionist/theming/ContactCenterThemeContext";
import { getSystemEventText } from "../utils/systemEventText.utils";

interface SystemEventBubbleProps {
  message: any;
  actorName: string;
}

export const SystemEventBubble = ({ message, actorName }: SystemEventBubbleProps) => {
  const { theme } = useContactCenterTheme();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", my: 0.5 }}>
      <Typography
        variant="caption"
        sx={{
          px: 1.5,
          py: 0.5,
          borderRadius: 999,
          maxWidth: "80%",
          textAlign: "center",
          fontSize: "0.7rem",
          lineHeight: 1.4,
          color: theme.chat.dividerText,
          backgroundColor: theme.chat.dividerLine,
        }}
      >
        {getSystemEventText(message, actorName)}
      </Typography>
    </Box>
  );
};
